import { createContext } from 'reka-ui';

interface NestedSelectMenuContext {
	closeAll: () => void;
	isTargetWithinMenu: (target: EventTarget | null) => boolean;
	menuId: string;
}

export const [injectNestedSelectMenuContext, provideNestedSelectMenuContext] = createContext<NestedSelectMenuContext>('NestedSelectMenu');
